import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaFileImage, FaFilePdf } from 'react-icons/fa';
import { API_BASE_URL } from '../config';
import Loader from './Loader';

const FileUploader = ({ apiEndpoint, businessId, userType }) =>
{
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [viewImage, setViewImage] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() =>
    {
        const loadImages = async () =>
        {
            try
            {
                const response = await axios.get(`${API_BASE_URL}/api/Media/media/${businessId}`);
                console.log('Fetched image data:', response.data);
                const sortedFiles = response.data.sort((a, b) => b.mediaId - a.mediaId);
                setUploadedFiles(sortedFiles);
            } catch (error)
            {
                console.error('Error loading images', error);
            }
        };
        loadImages();
    }, [apiEndpoint, businessId]);

    const handleFileChange = (e) =>
    {
        setFiles([...e.target.files]);
    };

    const handleUpload = async () =>
    {
        setLoading(true);
        const formData = new FormData();
        files.forEach((file) =>
        {
            formData.append('files', file);
        });
        formData.append('businessId', businessId);
        formData.append('userType', "businessreview");

        try
        {
            const response = await axios.post(`${API_BASE_URL}/api/Media/uploadimage`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) =>
                {
                    console.log(`Upload Progress: ${(progressEvent.loaded / progressEvent.total) * 100}%`);
                }
            });
            setUploadedFiles([...uploadedFiles, ...response.data]);
            setFiles([]);
        } catch (error)
        {
            console.error('Error uploading files', error);
        } finally
        {
            setLoading(false);
        }
    };

    const handleViewClick = (file) =>
    {
        setSelectedFile(file);
        setIsPopupOpen(true);
    };

    return (
        <>
            {loading ? <Loader /> : null}
            <div class="custom-upload-file">
                <div class="drag-drop-button">
                    <input
                        type="file"
                        ref={fileInputRef}
                        multiple
                        accept="image/*,application/pdf"
                        className="hidden"
                        onChange={handleFileChange}
                    />
                    <span >
                        <des title={files.length > 0 ? files.map(file => file.name).join(', ') : ''}>
                            {files.length > 1
                                ? `${files.length} files selected`
                                // :: ${files.map(file => file.name).join(', ')} 
                                : files.length === 1
                                    ? files[0].name
                                    : 'Click here to Upload'}
                        </des>
                    </span>

                </div>
                <button
                    className='upload-button'
                    onClick={handleUpload}
                    disabled={loading || files.length === 0}>
                    Upload Document
                </button>
            </div>
            <div className="uploaded-images">
                {uploadedFiles.map((file, index) => (
                    <div key={index} className="uploaded-file-box d-flex align-items-center">
                        <div class="file-name-icon">
                            {file.mediaUrl.endsWith(".pdf") ? (
                                <FaFilePdf className="text-red-500 mr-3" size={24} />
                            ) : (
                                <FaFileImage className="text-gray-500 mr-3" size={24} />
                            )}
                            <p className="font-semibold text-gray-800">
                                {file.mediaUrl.split('/').pop().split('_').pop()}
                            </p>

                        </div>
                        <button
                            type="button"
                            className="ml-auto bg-blue-500 text-white px-3 py-1 rounded"
                            onClick={(e) =>
                            {
                                e.stopPropagation();
                                handleViewClick(file);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalToggle"
                        >
                            View
                        </button>
                    </div>
                ))}

            </div >
            {isPopupOpen && (
                <div>
                    <div
                        className="modal fade"
                        id="exampleModalToggle"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalToggleLabel">
                                        File Preview
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body preview-modal-body">
                                    {selectedFile?.mediaUrl?.endsWith(".pdf") ? (
                                        <embed
                                            src={selectedFile.mediaUrl}
                                            type="application/pdf"
                                            width="100%"
                                            height="500px"
                                        />
                                    ) : (
                                        <img
                                            src={selectedFile.mediaUrl}
                                            className="mt-2 img-fluid"
                                            alt="Preview"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FileUploader;